<template>
  <div class="articleDetail container">
    <div class="ab">
      <div class="view container">
        <article-title/>
        <div class="ad">
          <div class="indexData">
            <div class="title">{{article.title}}</div>
            <div class="d1 container">
              <div v-if="article.good" class="good">精华</div>
              <div class="time">发表于 {{article.createTime | formatTime}}</div>
              <div class="itemCount">
                <span><i class="iconfont icon-browse"></i>&nbsp;{{article.visitCount | maxNumFix(999)}}</span>
                <span><i class="iconfont icon-comments"></i>&nbsp;{{article.replyCount | maxNumFix(99)}}</span>
                <span><i class="iconfont icon-praise"></i>&nbsp;{{article.handCount | maxNumFix(99)}}</span>
              </div>
            </div>
            <div class="dataContent" v-html="article.content" v-cloak>
                {{article.content}}
            </div>
            <div class="bottomDiv">&nbsp;</div>
            <div class="eval" ref="evalDiv" v-if="isLogin">
              <textarea v-model="eval" placeholder="说点什么..." @input="descInput(500)"></textarea>
              <div class="evalFoot">
                <div class="ent_lan">{{evalSize}}/500字</div>
                <div class="btn" @click="submitEval">评论</div>
              </div>
            </div>
            <div class="notLoginEval container" v-if="!isLogin">
              <div class="data">
                <div class="tips">你需要登录之后才能回帖</div>
                <router-link to="/login">
                  <div class="btn">登录</div>
                </router-link>
                <div>&nbsp;|&nbsp;</div>
                <router-link to="/register">
                  <div class="btn">注册</div>
                </router-link>
              </div>
            </div>
            <div class="evalHis">
              <div class="evalDetail">
                <div class="noEval" v-show="!dataLst || dataLst.length ===0">暂无相关数据</div>
                <div v-for="ed in dataLst" :key="ed.replyId" class="evalItem container"
                     @mouseenter="replyFocus = ed.replyId" @mouseleave="replyFocus = -1">
                  <div class="headImg">
                    <img :src="ed.headImg || defaultHead"/>
                    <div class="evalContent container">
                      <div class="evalD">
                        <div class="evalName">{{ed.userName}}</div>
                        <div class="evalTime">{{ed.createTime | formatTime}}</div>
                        <div class="evalReplyDiv" @click="replyShowChange(ed)" v-show="replyFocus === ed.replyId">回复</div>
                      </div>
                      <div class="ec" @click="replyShowChange(ed)">{{ed.content}}</div>
                    </div>
                    <div v-show="ed.replyId === replyShow" class="replyShow container">
                      <div class="replyName">回复：{{ed.userName}}</div>
                      <textarea v-model="ed.replyEval" @input="descInput(500, ed)"></textarea>
                      <div class="ent_lan">{{ed.evalSize || 0}}/500字</div>
                      <div class="replySubmit" @click="replySubmit(ed)">回复</div>
                    </div>
                    <div v-if="ed.parent" class="evalParent">
                      <span>回复：{{ed.parent.userName}}</span>
                      <div>{{ed.parent.content}}</div>
                    </div>
                    <!--<div class="k_good">你好呀</div>-->
                  </div>
                </div>
                <div v-show="MoreShow" class="loadMore" @click="getDataLst">查看更多</div>
              </div>
            </div>
          </div>
          <div class="dataRight right">
            <div class="user">
              <div class="userHead"><img :src="user.headImg || defaultHead"/></div>
              <router-link :to="{name: 'anotherHome',params: {userId:user.userId}}">
                <div class="userName">{{user.userName}}<img :src="v1"/></div>
              </router-link>
              <div class="userRole">车灯社区认证用户</div>
              <div class="score">积分：{{user.score}}</div>
              <div class="notFocus" v-if="isFocus > 0 && isFocus%2 === 0" @click="focus(true)">+关注</div>
              <div class="isFocus"  @mouseenter="focusMsg='取消关注'" @mouseleave="focusMsg='已关注'"
                   v-if="isFocus > 0 && isFocus%2 === 1" @click="focus(false)">{{focusMsg}}</div>
              <div class="newArticle">
                <div class="title">最新主题</div>
                <div class="newList">
                  <div v-for="ns in newArticleList" class="item" :key="ns.articleId">
                    <div @click="reloadPage(ns.articleId)"><span :class="ns.articleWay">{{ns.articleWay | articleWayFilter}}</span>{{ns.title}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="fun">
              <div v-if="!isCollect" @click="hand(true,'collect')"><i class="iconfont icon-collection"></i>&nbsp;收藏</div>
              <div v-if="isCollect" @click="hand(false,'collect')">取消收藏</div>
              <div v-if="!isHand" @click="hand(true,'hand')"><i class="iconfont icon-praise"></i>&nbsp;点赞</div>
              <div v-if="isHand" @click="hand(false,'hand')">取消点赞</div>
              <div @click="getEvalDiv">
                <i class="iconfont icon-comments"></i>&nbsp;评论
              </div>
            </div>
          </div>
        </div>
        <loading text='加载中...' duration='2s' v-show="isLoad"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import articleTitle from '../common/articleTitle.vue'
import loading from '../common/loading.vue'
export default {
  name: 'userMain',
  data () {
    return {
      focusMsg: '已关注',
      MoreShow: false,
      v1: require('../../assets/icon/V1.png'),
      isLoad: true,
      msg: '个人首页',
      articleId: 3,
      replyFocus: -1,
      replyShow: -1,
      parentId: null,
      eval: '',
      evalSize: 0,
      page: 1,
      pageSize: 5,
      totalPages: 10,
      isHand: false,
      isFocus: 0,
      isCollect: false,
      isLogin: false,
      userId: '',
      defaultHead: require('../../assets/image/installer.png'),
      user: {
        'userName': '叶子',
        'headImg': 'http://www.naolamp.cn/sale/./common/getImage?id=group1/M00/00/21/rBLvXFomX3mEKnYRAAAAABbjd2Y774.jpg',
        'score': 50,
        'articleNum': 5,
        'focusNum': 5,
        'userId': 'a0382e6e-9ad0-4ece-b1fb-f288d67ceb89'
      },
      newArticleList: [{
        'summary': '一论坛九加一论坛九加一论坛九加一论坛\r\n九加一论坛九加一',
        'headImg': null,
        'frontImage': 'http://video.naolamp.com/bbs_front/1529894447474.jpg',
        'articleId': 14,
        'userName': '用户9569',
        'title': '九加一论坛',
        'userId': '402888c563f7211f0163f721b2d10000',
        'good': 'N',
        'articleWay': 'Y',
        'isRelease': 'Y',
        'replyCount': 2,
        'lastReplyTime': 1529894504000,
        'visitCount': 4,
        'tab': 'DG_AL',
        'top': 'N',
        'createTime': 1529894447000,
        'handCount': 0,
        'open': 'Y'
      }],
      article: {
        'articleId': 3,
        'userId': 'a0382e6e-9ad0-4ece-b1fb-f288d67ceb89',
        'tab': 'spring,spring cloud,JAVA,',
        'content': '加载中...',
        'summary': '',
        'frontImage': 'http://video.naolamp.com/bbs_front/1528362205355.png',
        'title': '',
        'lastReplyTime': 1528362205000,
        'createTime': 1528362205000,
        'good': true,
        'articleWay': 'Z',
        'top': false,
        'open': true,
        'release': true,
        'replyCount': 9999,
        'visitCount': 9999,
        'handCount': 9999
      },
      dataLst: [{
        'replyId': 1,
        'userName': '叶子',
        'parentId': null,
        'headImg': 'http://www.naolamp.cn/sale/./common/getImage?id=group1/M00/00/21/rBLvXFomX3mEKnYRAAAAABbjd2Y774.jpg',
        'createTime': 1528362205000,
        'content': '不错哟',
        'articleId': 1,
        'parent': null
      }, {
        'replyId': 2,
        'userName': '叶子',
        'parentId': 1,
        'headImg': 'http://video.naolamp.com/bbs/1528362159261.jpg',
        'createTime': 1528362205000,
        'content': '不错哟',
        'articleId': 1,
        'parent': {
          'replyId': 1,
          'userName': '叶子',
          'parentId': null,
          'createTime': 1528362205000,
          'content': '长一点要让他换行长一点要让他换行长一点要让他换行长一点要让他换行长一点要让他换行长一点要让他换行',
          'articleId': 1,
          'parent': null
        }
      }]
    }
  },
  computed: {
  },
  mounted: function (s) {
    this.getParams()
    this.getArticleDetail()
    window.scrollTo(0, 0)
    this.isLoad = false
    this.userId = this.$root.getUserId()
  },
  methods: {
    focus: function (f) {
      let that = this
      that.isLoad = true
      that.axios.post('/user/follow', {
        fromId: that.$store.state.user.userId,
        toId: that.article.userId,
        flag: f
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          if (f) {
            that.isFocus += 1
          } else {
            that.isFocus += 1
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    hand: function (h, fun) {
      let that = this
      that.isLoad = true
      that.axios.post('/topic/' + fun, {
        userId: that.$store.state.user.userId,
        articleId: that.articleId,
        hand: h
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          if (h) {
            if (fun === 'hand') {
              that.article.handCount++
              that.isHand = true
            } else {
              that.isCollect = true
            }
          } else {
            if (fun === 'hand') {
              that.article.handCount--
              that.isHand = false
            } else {
              that.isCollect = false
            }
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    getEvalDiv: function () {
      window.scrollTo(0, this.$refs.evalDiv.offsetTop - 100)
    },
    reloadPage: function (articleId) {
      if (this.articleId !== articleId) {
        this.isLoad = true
        localStorage.setItem('articleId', articleId)
        this.articleId = articleId
        this.getArticleDetail()
      }
    },
    'replySubmit': function (reply) {
      this.submitData(reply.replyEval, reply.replyId)
      reply.replyEval = ''
      reply.evalSize = 0
      this.replyShow = -1
    },
    getParams () {
      // 取到路由带过来的参数
      let obj = this.$route.params
      let qo = this.$route.query
      // 将数据放在当前组件的数据内
      if (obj.articleId) {
        this.articleId = obj.articleId
        localStorage.setItem('articleId', this.articleId)
      } else if (qo.articleId) {
        this.articleId = qo.articleId
        localStorage.setItem('articleId', this.articleId)
      } else if (localStorage.getItem('articleId')) {
        this.articleId = localStorage.getItem('articleId')
      } else {
        this.$router.push('/')
      }
      if (localStorage.user) {
        this.isLogin = localStorage.token
      }
    },
    'replyShowChange': function (ed) {
      let index = ed.replyId
      if (ed.userId === this.userId) {
        return
      }
      if (this.replyShow === index) {
        this.replyShow = -1
      } else {
        this.replyShow = index
      }
    },
    getArticleDetail () {
      let that = this
      that.isLoad = true
      that.page = 1
      that.axios.post('/topic/detail', {
        userId: that.$store.state.user.userId,
        pageSize: that.pageSize,
        page: that.page,
        articleId: that.articleId
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          let val = response.data.value
          that.user = val.user
          that.newArticleList = val.newArticleList
          that.article = val.article
          that.dataLst = val.eval.dataLst
          if (val.eval.dataLst.length >= that.pageSize) {
            that.MoreShow = true
          } else {
            that.MoreShow = false
          }
          that.isHand = val.isHand
          that.isFocus = val.isFocus
          that.isCollect = val.isCollect
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    'getDataLst': function () {
      this.isLoad = true
      let that = this
      that.page = that.page + 1
      that.axios.post('topic/getEvals', {
        articleId: that.articleId,
        page: that.page,
        pageSize: that.pageSize
      }, {
        emulateJSON: true// 需要转json
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          var res = response.data.value
          if (that.page === 1) {
            that.dataLst = res.dataLst
          } else {
            that.dataLst = that.dataLst.concat(res.dataLst)
          }
          if (res.dataLst.length >= that.pageSize) {
            that.MoreShow = true
          } else {
            that.MoreShow = false
          }
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    submitEval () {
      this.submitData(this.eval, null)
      this.evalSize = 0
    },
    'submitData': function (e, p) {
      if (!this.$root.checkLogin()) {
        this.$store.commit('setToastMsg', '请登录后操作')
        return ''
      }
      let that = this
      that.isLoad = true
      that.axios.post('/topic/eval', {
        userId: that.$store.state.user.userId,
        articleId: that.articleId,
        parentId: p,
        content: e
      }, {
        emulateJSON: true
      }).then(function (response) {
        that.isLoad = false
        if (response.data.status === 0) {
          that.eval = ''
          that.page = 0
          that.getDataLst()
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.isLoad = false
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    descInput (m, e) {
      if (e) {
        if (e.replyEval) {
          if (e.replyEval.length > m) {
            e.replyEval = e.replyEval.substr(0, m)
          }
          e.evalSize = e.replyEval.length
        }
      } else {
        if (this.eval.length > m) {
          this.eval = this.eval.substr(0, m)
        }
        this.evalSize = this.eval.length
      }
    }
  },
  filters: {
  },
  components: {
    articleTitle,
    loading
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.articleDetail {
  padding-top: 52px;
}
.ab {
  width: 100%;
  min-width: 1200px;
  background-color: #F0F0F0;
}
.articleDetail .view {
  width: 1200px;
  margin: 0 auto;
}
.view .ad {
  margin-top: 20px;
}
.indexData {
  float: left;
  width: 850px;
  margin-bottom: 50px;
  padding: 40px 25px;
  text-align: left;
  background-color: #FFFFFF;
}
.indexData .title {
  font-size: 25px;
  color: #333333;
  font-family: FZYH_510M;
  padding-bottom: 30px;
}
.d1 {
  width: 850px;
  padding-bottom: 10px;
  border-bottom: 1px solid #E3E3E3;
}
.d1 .good {
  float: left;
  width: 69px;
  height: 28px;
  line-height: 28px;
  background-color: #E0E0E0;
  text-align: center;
  color: red;
  margin-right: 40px;
}
.d1 .time {
  float: left;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  color: black;
}
.d1 .itemCount {
  float: right;
  display: flex;
}
.itemCount span {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  padding-right: 10px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.icon-browse,
.icon-comments,
.icon-praise{
  font-size: 20px;
}
.dataContent {
  padding: 30px 0;
  line-height: 25px;
}
.bottomDiv {
  background-color: #F0F0F0;
  width: 900px;
  margin-left: -25px;
}
.notLoginEval {
  margin: 20px 0;
  background-color: #F0F0F0;
  text-align: center;
  line-height: 86px;
}
.notLoginEval .tips {
  padding-right: 20px;
}
.notLoginEval .btn {
  color: #007eff;
  cursor: pointer;
}
.notLoginEval .data {
  width: 300px;
  margin: 0 auto;
}
.notLoginEval .data div {
  float: left;
}
.eval{
  margin: 25px 0 10px 0;
  padding-bottom: 40px;
}
.eval textarea,.replyShow textarea{
  padding: 10px;
  width: 100%;
  height: 80px;
  resize: vertical;
  font-size: 16px;
  border-radius: 3px;
  background-color: #F0F0F0;
  box-sizing: border-box;
}
.replyName {
  padding: 5px;
  width: 100%;
  float: left;
  box-sizing: border-box;
  background-color: #F0F0F0;
}
.ent_lan {
  float: left;
  padding: 5px 0;
  width: 300px;
}
.evalFoot .btn {
  float: right;
  /*margin-right: 10px;*/
  /*padding: 5px 20px;*/
  width: 87px;
  height: 33px;
  line-height: 33px;
  text-align: center;
  background-color: #05b570;
  color: white;
  cursor: pointer;
  margin-top: 2px;
}
.evalDetail {
  min-height: 100px;
  border-top: 1px solid #d2d2d2;
}
.noEval {
  text-align: center;
  font-size: 30px;
  line-height: 120px;
  color: #999;
}
.evalItem{
  background-color: #FFFFFF;
  padding-top: 27px;
  padding-bottom: 30px;
  border-bottom: 1px solid #d2d2d2;
}
.headImg img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  float: left;
}
.evalContent {
  padding-left: 20px;
  float: left;
}
.evalD {
  height: 30px;
}
.evalName {
  line-height: 30px;
  font-family: FZYH_510M;
  font-size: 16px;
  float: left;
  padding-right: 30px;
}
.evalReplyDiv {
  color: #06B570;
  line-height: 30px;
  font-size: 16px;
  /*float: left;*/
  float: right;
  margin-left: 450px;
  cursor: pointer;
}
.evalReplyDiv:hover {
  border-bottom: 1px solid #d2d2d2;
}
.evalTime {
  display: inline-block;
  font-size: 12px;
  color: black;
  line-height: 30px;
  /*float: right;*/
  padding: 0;
}
.evalParent {
  background-color: #F0F0F0;
  padding: 5px;
  margin-left: 50px;
  width: 720px;
  display: inline-block;
}
.evalContent .ec{
  font-size: 14px;
  padding-top: 17px;
  padding-bottom: 19px;
  width: 720px;
}
.evalContent .ec:hover{
  opacity: .6;
}
.replyShow .replySubmit {
  height: 30px;
  line-height: 30px;
  float: right;
  color: red;
  cursor: pointer;
}
.loadMore {
  padding-top: 20px;
  width: 850px;
  text-align: center;
  color: #06B570;
  font-size: 14px;
}
.dataRight {
  float: left;
  width: 290px;
  text-align: left;
  margin-left: 10px;
}
.user {
  width: 250px;
  background-color: #FFFFFF;
  padding: 20px;
}
.user .userName {
  font-size: 16px;
  font-family: FZYH_510M;
  line-height: 30px;
}
.user .userName:hover {
  color: #6b6b6b;
}
.user .userName img{
  padding-left: 10px;
}
.user .userRole,.user .score {
  font-size: 14px;
  line-height: 20px;
}
.user .notFocus,.user .isFocus{
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #05b570;
  color: #FFFFFF;
  text-align: center;
  width: 70px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  cursor: pointer;
}
.user .isFocus {
  background-color: #E0E0E0;
}
.user .isFocus:hover {
  color: #05b570;
}
.user .userHead {
  float: right;
}
.user .userHead img{
  width: 70px;
  height: 70px;
  border-radius: 50%;
}
.newArticle .title {
  font-size: 14px;
  line-height: 40px;
  font-family: FZYH_510M;
  border-bottom: 1px solid #E3E3E3;
}
.newArticle .item div{
  padding: 10px 0;
  cursor: pointer;
}
.newArticle .item div:hover{
  color: #06B570;
}
.item .Z {
  background-color: #959eca;
  padding: 2px;
  color: white;
  font-size: 14px;
  margin-right: 10px;
}
.item .Y {
  background-color: #05B570;
  padding: 2px;
  color: white;
  font-size: 14px;
  margin-right: 10px;
}
.fun {
  margin-top: 10px;
  background-color: #FFFFFF;
  padding: 20px 0;
  width: 290px;
  text-align: center;
  height: 33px;
}
.fun div {
  margin-left: 12px;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  background-color: #05b570;
  height: 33px;
  border-radius: 2px;
  color: #FFFFFF;
  cursor: pointer;
}
.icon-collection,
.icon-praise,
.icon-comments{
  font-size: 20px;
}
  .k_good{
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/article/articleDetail.vue